import * as React from 'react';
import NextLink from 'next/link';

export const NextLinkWrapper = React.forwardRef<
  any,
  { children: React.ReactNode; href: string; disabled?: boolean }
>(function NextLinkWrapper({ href, children, ...linkProps }, ref) {
  if (
    !linkProps.disabled &&
    (typeof href !== 'string' || href.startsWith('/'))
  ) {
    return (
      <NextLink href={href || ''}>
        <a {...linkProps}>{children}</a>
      </NextLink>
    );
  }
  return (
    <a href={href} {...linkProps} ref={ref}>
      {children}
    </a>
  );
});
